import $ from "jquery";

class LoadMore {
  constructor() {
    this.kachel = $(".single_kachel");
    this.showmore = $(".showmore");

    // Show only the first 15 items
    this.kachel.slice(0, 15).addClass("show");

    // Initially check if we need to disable the button
    this.checkButtonState();

    this.events();
  }

  events() {
    this.showmore.on("click", (event) => this.more(event));
  }

  more(event) {
    event.preventDefault();

    // Show the next 8 hidden items
    $(".single_kachel:not(.show)").slice(0, 8).addClass("show");

    // Check if there are no more items to show and disable the button if necessary
    this.checkButtonState();
  }

  checkButtonState() {
    // If there are no more items to show, disable the button
    if ($(".single_kachel:not(.show)").length === 0) {
      this.showmore.prop("disabled", true);
      // Change the text color of the button to indicate it's inactive
      //this.showmore.css("color", "grey"); // You can replace "grey" with any color you prefer
      // Optionally, change the cursor to indicate the button is not clickable
      //this.showmore.css("cursor", "not-allowed");
      this.showmore.addClass("disabled");
    }
  }
}

export default LoadMore;
